import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { HorizontalPosition, ToastExtended, ToastType } from '../../models/toast.model';

const containerClassMapper: Record<ToastType, string> = {
  error: 'bewp-toast-notification--error',
  warning: 'bewp-toast-notification--warning',
  success: 'bewp-toast-notification--success',
  information: 'bewp-toast-notification--info',
  'primary-dark': 'bewp-toast-notification--primary-dark',
  'primary-light': 'bewp-toast-notification--primary-light',
  'primary-responsive': 'bewp-toast-notification--primary-responsive',
  'primary-responsive-inverted': 'bewp-toast-notification--primary-responsive-inverted',
};

@Component({
  selector: 'app-toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.scss'],
  imports: [CommonModule],
})
export class ToastNotificationComponent {
  @Input() set toast(toast: ToastExtended) {
    this._toast = toast;
    this.containerClass = this.getContainerClass(toast.notificationType || 'primary-dark');
    this.hasIcon = !toast.notificationType.includes('primary');
    if (toast.horizontalPosition) {
      this.hostClass = toast.horizontalPosition;
    }
  }
  @Output() removeToast: EventEmitter<ToastExtended> = new EventEmitter();

  @HostBinding('class') hostClass: HorizontalPosition;

  _toast: ToastExtended;
  containerClass: string;
  hasIcon: boolean;

  getContainerClass(notificationType: ToastType): string {
    return containerClassMapper[notificationType];
  }
}
